<template>
  <div v-show="visible" @keyup.enter="onClickOnSubmit()" class="bmc-canvas__item-input">
    <button :style="{'background-color': buttonBackgroundColor}" @click="onClickOnCreate()" class="hide-print mdc-fab mdc-fab--mini" aria-label="Favorite">
      <span class="mdc-fab__icon material-icons">add</span>
    </button>
    <div
      class="mdc-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content"
    >
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title" id="my-dialog-title">Create item</h2>
          <div class="mdc-dialog__content" id="my-dialog-content">
            <Input v-model="model" label="Description"></Input>
          </div>
          <footer class="mdc-dialog__actions">
            <button
              type="button"
              class="mdc-button mdc-dialog__button"
              data-mdc-dialog-action="close"
            >
              <span class="mdc-button__label">Cancel</span>
            </button>
            <button @click="onClickOnSubmit()" type="button" class="mdc-button mdc-button--raised mdc-dialog__button">
              <span class="mdc-button__label">Create</span>
            </button>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>
  </div>
</template>

<script>
import { MDCRipple } from "@material/ripple";
import { MDCDialog } from "@material/dialog";
import Input from './Input.vue';

export default {
  name: "canvas-item-input",
  props: ['visible', 'buttonBackgroundColor'],
  mounted() {
    const fabRipple = new MDCRipple(this.$el.querySelector(".mdc-fab"));
    this.dialog = new MDCDialog(this.$el.querySelector(".mdc-dialog"));
  },
  data() {
    return {
      dialog: null,
      model: ""
    };
  },
  methods: {
    onClickOnSubmit() {
      if(!this.model) {
        console.warn(`Model must be fulfilled`);
        return;
      }
      this.dialog.close();
      this.$emit("submit", this.model);
      this.model = "";
    },
    onClickOnCreate() {
      this.dialog.open();
    }
  },
  components: {
    Input
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mdc-fab {
  background-color: var(--mdc-theme-secondary);
  color: #fff;
}
.bmc-canvas__item-input {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CanvasItemInput.vue